<template>
    <form class="h-full w-full flex flex-col p-8" @submit.prevent="submitForm">
        <div class="h-full flex justify-center items-center" v-if="$apollo.queries.student.loading">
            <base-spinner></base-spinner></div>
        <div v-else class="h-full w-full flex flex-col">
            <div class="w-full flex justify-start items-center bg-1 shadow-lg rounded-2xl p-2 sm:p-4 relative">
                <div class="h-12 sm:h-16 lg:h-20 w-12 sm:w-16 lg:w-20 mr-2 sm:mr-4 flex-shrink-0">
                    <img class="h-full w-full object-cover rounded-xl" :src="getProfilePicture" alt="avatar">
                </div>
                <div class="flex-grow flex flex-col">
                    <h1 class="text-base sm:text-lg lg:text-xl font-medium capitalize break-all">{{ student.name_en }}
                    </h1>
                    <p class="text-xs lg:text-sm text-gray-600 break-all">{{ student.primary_email }}</p>
                </div>
            </div>
            <div class="mt-8 w-full flex justify-start items-center flex-wrap relative bg-transparent rounded-xl">
                <div v-for="(tab, index) in tabs" :key="index" class="px-4 cursor-pointer transition-all"
                    :class="activeTab == tab.id ? 'text-tab' : 'text-gray-600'" :id="tab.id" @click="selectTab(tab.id)">
                    {{ tab.name }}</div>
                <div :style="getActiveTabStyle"
                    class="active-tab z-10 absolute rounded-lg bg-inherit flex-auto text-center bg-none border-0 block">
                </div>
            </div>
            <div class="grid grid-col-1 gap-4 mt-8">
                <transition name="fade" mode="out-in">
                    <div v-if="activeTab == 'personal-information'" class="w-full flex flex-col border rounded-2xl p-4">
                        <div class="flex text-xs sm:text-sm lg:text-base">
                            <div class="font-semibold capitalize w-40">English Name</div>
                            <div class="text-gray-600"><span class="mr-4">:</span>{{ student.name_en }}</div>
                        </div>
                        <div class="flex mt-1 text-xs sm:text-sm lg:text-base">
                            <div class="font-semibold w-40">Arabic Name</div>
                            <div class="text-gray-600"><span class="mr-4">:</span>{{ student.name_ar }}</div>
                        </div>
                        <div class="flex mt-1 text-xs sm:text-sm lg:text-base">
                            <div class="font-semibold w-40">Emirates ID</div>
                            <div class="text-gray-600"><span class="mr-4">:</span>{{ student.eid }}</div>
                        </div>
                        <div class="flex mt-1 text-xs sm:text-sm lg:text-base">
                            <div class="font-semibold w-40">Nationality</div>
                            <div class="text-gray-600"><span class="mr-4">:</span>{{ student.nationality }}</div>
                        </div>
                        <div class="flex mt-1 text-xs sm:text-sm lg:text-base">
                            <div class="font-semibold w-40">Gender</div>
                            <div class="text-gray-600 capitalize"><span class="mr-4">:</span>{{ student.gender ?
                                student.gender == 'M' ? 'Male' : 'Female' : '' }}</div>
                        </div>
                        <div class="flex mt-1 text-xs sm:text-sm lg:text-base">
                            <div class="font-semibold w-40">Date Of Birth</div>
                            <div class="text-gray-600"><span class="mr-4">:</span>{{ formattedDate(student.birthdate) }}
                            </div>
                        </div>
                        <div class="w-1/2 flex items-center mt-1 text-xs sm:text-sm lg:text-base">
                            <div class="font-semibold w-40 flex-shrink-0">Expire EID</div>
                            <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                <div class="flex flex-col flex-grow">
                                    <input type="date" class="" v-model.trim="expireEid.val" placeholder=""
                                        @blur="clearValidity('expireEid')" @keypress="allowNumbersOnly" />
                                    <transition name="form-fade" mode="out-in">
                                        <p v-if="!expireEid.isValid" class="h-4 text-xs text-red-600">
                                            {{ expireEid.msg }}
                                        </p>
                                    </transition>
                                </div>
                            </div>
                        </div>
                        <div class="w-1/2 flex items-center mt-1 text-xs sm:text-sm lg:text-base">
                            <div class="font-semibold w-40 flex-shrink-0">Primary Phone</div>
                            <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                <div class="flex flex-col flex-grow">
                                    <input type="text" class="" v-model.trim="primaryPhone.val" placeholder=""
                                        @blur="clearValidity('primaryPhone')" @keypress="allowNumbersOnly" />
                                    <transition name="form-fade" mode="out-in">
                                        <p v-if="!primaryPhone.isValid" class="h-4 text-xs text-red-600">
                                            {{ primaryPhone.msg }}
                                        </p>
                                    </transition>
                                </div>
                            </div>
                        </div>
                        <div class="w-1/2 flex items-center mt-1 text-xs sm:text-sm lg:text-base">
                            <div class="font-semibold w-40 flex-shrink-0">Secondary Phone</div>
                            <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                <div class="flex flex-col flex-grow">
                                    <input type="text" v-model.trim="secondaryPhone.val" placeholder=""
                                        @keypress="allowNumbersOnly" />
                                </div>
                            </div>
                        </div>
                        <div class="w-1/2 flex items-center mt-1 text-xs sm:text-sm lg:text-base">
                            <div class="font-semibold w-40 flex-shrink-0">Personal Email</div>
                            <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                <div class="flex flex-col flex-grow">
                                    <input type="text" v-model.trim="secendoryEmail.val" placeholder=""
                                        @blur="clearValidity('secendoryEmail')" />
                                    <transition name="form-fade" mode="out-in">
                                        <p v-if="!secendoryEmail.isValid" class="h-4 text-xs text-red-600">
                                            {{ secendoryEmail.msg }}
                                        </p>
                                    </transition>
                                </div>
                            </div>
                        </div>
                        <div class="w-1/2 flex items-center mt-1 text-xs sm:text-sm lg:text-base">
                            <div class="font-semibold w-40 flex-shrink-0">Marital Status</div>
                            <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                <div class="flex flex-col flex-grow">
                                    <select class="ht-42" v-model.trim="maritalStatus.val" id="marital-status"
                                        @blur="clearValidity('maritalStatus')">
                                        <option value="">Select Marital Status</option>
                                        <option value="S">Single</option>
                                        <option value="M">Married</option>
                                        <option value="W">Widowed</option>
                                        <option value="D">Divorced</option>
                                    </select>
                                    <transition name="form-fade" mode="out-in">
                                        <p v-if="!maritalStatus.isValid" class="h-4 text-xs text-red-600">
                                            {{ maritalStatus.msg }}
                                        </p>
                                    </transition>
                                </div>
                            </div>
                        </div>
                        <div class="w-1/2 flex items-center mt-1 text-xs sm:text-sm lg:text-base">
                            <div class="font-semibold w-40 flex-shrink-0">Emirate</div>
                            <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                <div class="flex flex-col flex-grow">
                                    <select class="ht-42" v-model.trim="emirate.val" id="marital-status">
                                        <option value="">Select Emirate</option>
                                        <option value="Abu Dhabi">Abu Dhabi</option>
                                        <option value="Dubai">Dubai</option>
                                        <option value="Sharjah">Sharjah</option>
                                        <option value="Ajman">Ajman</option>
                                        <option value="Umm Al Quwain">Umm Al Quwain</option>
                                        <option value="Ras Al Khaimah">Ras Al Khaimah</option>
                                        <option value="Fujairah">Fujairah</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="w-1/2 flex items-center mt-1 text-xs sm:text-sm lg:text-base">
                            <div class="font-semibold w-40 flex-shrink-0">City</div>
                            <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                <div class="flex flex-col flex-grow">
                                    <input type="text" v-model.trim="city.val" placeholder="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="activeTab == 'academic-information'"
                        class="w-full flex flex-col border rounded-2xl p-4">


                        <div v-if="showHighSchoolDetailsView">
                            <h1 class="font-medium text-xs sm:text-sm lg:text-base text-tab">High School Details</h1>
                            <div class="flex mt-3 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40">High School Name</div>
                                <div class="text-gray-600"><span class="mr-4">:</span>{{ student.campus }}</div>
                            </div>
                            <div class="flex mt-1 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40">Average</div>
                                <div class="text-gray-600"><span class="mr-4">:</span>{{ student.gpa }}</div>
                            </div>
                            <div class="flex mt-1 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40">Stream</div>
                                <div class="text-gray-600"><span class="mr-4">:</span>{{ student.study_program }}</div>
                            </div>
                            <div class="flex mt-1 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40">Graduation Year</div>
                                <div class="text-gray-600"><span class="mr-4">:</span>{{ student.grad_year }}</div>
                            </div>
                            <div class="flex mt-1 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40">Location</div>
                                <div class="text-gray-600"><span class="mr-4">:</span>{{ student.location }}</div>
                            </div>
                        </div>

                        <div v-if="showHighSchoolDetailsEdit">
                            <h1 class="font-medium text-xs sm:text-sm lg:text-base text-tab">High School Details</h1>
                            <div class="w-2/3 flex items-center mt-3 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40 flex-shrink-0">High School Name</div>
                                <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                    <div class="flex flex-col flex-grow">
                                        <input type="text" v-model.trim="schoolName.val" placeholder="" />
                                    </div>
                                </div>
                            </div>
                            <div class="w-2/3 flex items-center mt-3 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40 flex-shrink-0">Average</div>
                                <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                    <div class="flex flex-col flex-grow">
                                        <input type="text" v-model.trim="schoolAverage.val" placeholder="" />
                                    </div>
                                </div>
                            </div>
                            <div class="w-2/3 flex items-center mt-3 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40 flex-shrink-0">Stream</div>
                                <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                    <div class="flex flex-col flex-grow">
                                        <input type="text" v-model.trim="schoolStream.val" placeholder="" />
                                    </div>
                                </div>
                            </div>
                            <div class="w-2/3 flex items-center mt-3 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40 flex-shrink-0">Graduation Year</div>
                                <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                    <div class="flex flex-col flex-grow">
                                        <input type="text" v-model.trim="schoolGraduationYear.val" placeholder="" />
                                    </div>
                                </div>
                            </div>
                            <div class="w-2/3 flex items-center mt-3 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40 flex-shrink-0">Location</div>
                                <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                    <div class="flex flex-col flex-grow">
                                        <input type="text" v-model.trim="schoolLocation.val" placeholder="" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="showUniversityDetailsView" class="mt-4">
                            <h1 class="font-medium text-xs sm:text-sm lg:text-base text-tab">University Details</h1>
                            <div class="flex mt-3 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40">College Name</div>
                                <div class="text-gray-600"><span class="mr-4">:</span>{{ student.campus }}</div>
                            </div>
                            <div class="flex mt-1 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40">Location</div>
                                <div class="text-gray-600"><span class="mr-4">:</span>{{ student.location }}</div>
                            </div>
                            <div class="flex mt-1 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40">Year Of Starting</div>
                                <div class="text-gray-600"><span class="mr-4">:</span></div>
                            </div>
                            <div class="flex mt-1 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40">Graduation Year</div>
                                <div class="text-gray-600"><span class="mr-4">:</span>{{ student.grad_year }}</div>
                            </div>
                            <div class="flex mt-1 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40">GPA</div>
                                <div class="text-gray-600"><span class="mr-4">:</span>{{ student.gpa }}</div>
                            </div>
                            <div class="flex mt-1 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40">Academic Major(s)</div>
                                <div class="text-gray-600"><span class="mr-4">:</span>{{ student.study_program }}</div>
                            </div>
                            <div class="flex mt-1 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40">Sponsor</div>
                                <div class="text-gray-600"><span class="mr-4">:</span></div>
                            </div>
                        </div>


                        <div v-if="showUniversityDetailsEdit" class="mt-4">
                            <h1 class="font-medium text-xs sm:text-sm lg:text-base mt-4 text-tab">University Details
                            </h1>
                            <div class="w-2/3 flex items-center mt-3 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40 flex-shrink-0">College Name</div>
                                <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                    <div class="flex flex-col flex-grow">
                                        <input type="text" v-model.trim="collegeName.val" placeholder="" />
                                    </div>
                                </div>
                            </div>
                            <div class="w-2/3 flex items-center mt-3 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40 flex-shrink-0">Location</div>
                                <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                    <div class="flex flex-col flex-grow">
                                        <input type="text" v-model.trim="collegeLocation.val" placeholder="" />
                                    </div>
                                </div>
                            </div>
                            <div class="w-2/3 flex items-center mt-3 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40 flex-shrink-0">Graduation Year</div>
                                <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                    <div class="flex flex-col flex-grow">
                                        <input type="text" v-model.trim="collegeGraduationYear.val" placeholder=""
                                            maxlength="4" @keypress="allowNumbersOnly" />
                                    </div>
                                </div>
                            </div>
                            <div class="w-2/3 flex items-center mt-3 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40 flex-shrink-0">Year of Starting</div>
                                <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                    <div class="flex flex-col flex-grow">
                                        <input type="text" v-model.trim="collegeYearOfstarting.val" placeholder=""
                                            maxlength="4" @keypress="allowNumbersOnly" />
                                    </div>
                                </div>
                            </div>
                            <div class="w-2/3 flex items-center mt-3 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40 flex-shrink-0">Academic Major(s)</div>
                                <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                    <div class="flex flex-col flex-grow">
                                        <input type="text" v-model.trim="collegeAcademicMajors.val" placeholder="" />
                                    </div>
                                </div>
                            </div>
                            <div class="w-2/3 flex items-center mt-3 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40 flex-shrink-0">GPA</div>
                                <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                    <div class="flex flex-col flex-grow">
                                        <input type="text" v-model.trim="collegeGpa.val" placeholder="" />
                                    </div>
                                </div>
                            </div>
                            <div class="flex items-center mt-1 text-xs sm:text-sm lg:text-base">
                                <div class="font-semibold w-40 flex-shrink-0">Sponsor</div>
                                <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                    <div class="flex flex-col flex-grow">
                                        <div class="flex">
                                            <input type="radio" id="collegeSponsor-yes" v-model="collegeSponsor.val"
                                                :value="true" @click="clearValidity('collegeSponsor')">
                                            <div class="mr-4 ml-1">Yes</div>
                                            <input type="radio" id="collegeSponsor-no" v-model="collegeSponsor.val"
                                                :value="false" @click="clearValidity('collegeSponsor')">
                                            <div class="ml-1">No</div>
                                        </div>
                                        <transition name="form-fade" mode="out-in">
                                            <p v-if="!collegeSponsor.isValid" class="h-4 text-xs text-red-600">
                                                {{ collegeSponsor.msg }}
                                            </p>
                                        </transition>
                                    </div>
                                </div>
                            </div>
                        </div>



                    </div>
                    <div v-else class="w-full flex flex-col border rounded-2xl p-4">
                        <div class="w-2/3 flex items-center mt-1 text-xs sm:text-sm lg:text-base">
                            <div class="font-semibold w-56 flex-shrink-0">Are you currently working?</div>
                            <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                <div class="flex flex-col flex-grow">
                                    <div class="flex">
                                        <input type="radio" id="employed-yes" v-model="employed.val" :value="true"
                                            @click="clearValidity('employed')">
                                        <div class="mr-4 ml-1">Yes</div>
                                        <input type="radio" id="employed-no" v-model="employed.val" :value="false"
                                            @click="clearValidity('employed')">
                                        <div class="ml-1">No</div>
                                    </div>
                                    <transition name="form-fade" mode="out-in">
                                        <p v-if="!employed.isValid" class="h-4 text-xs text-red-600">
                                            {{ employed.msg }}
                                        </p>
                                    </transition>
                                </div>
                            </div>
                        </div>
                        <transition name="form-fade" mode="out-in">
                            <div v-if="employed.val" class="flex flex-col mt-1">
                                <div class="w-2/3 flex items-center mt-1 text-xs sm:text-sm lg:text-base">
                                    <div class="font-semibold w-56 flex-shrink-0">Employer</div>
                                    <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                        <div class="flex flex-col flex-grow">
                                            <input type="text" class="" v-model.trim="employer.val" placeholder=""
                                                @blur="clearValidity('employer')" />
                                            <transition name="form-fade" mode="out-in">
                                                <p v-if="!employer.isValid" class="h-4 text-xs text-red-600">
                                                    {{ employer.msg }}
                                                </p>
                                            </transition>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-2/3 flex items-center mt-1 text-xs sm:text-sm lg:text-base">
                                    <div class="font-semibold w-56 flex-shrink-0">Sector</div>
                                    <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                        <div class="flex flex-col flex-grow">
                                            <select class="ht-42" v-model.trim="employementSector.val"
                                                @blur="clearValidity('employementSector')">
                                                <option value="">Select Sector</option>
                                                <option value="government">Government</option>
                                                <option value="private">Private</option>
                                            </select>
                                            <transition name="form-fade" mode="out-in">
                                                <p v-if="!employementSector.isValid" class="h-4 text-xs text-red-600">
                                                    {{ employementSector.msg }}
                                                </p>
                                            </transition>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-2/3 flex items-center mt-1 text-xs sm:text-sm lg:text-base">
                                    <div class="font-semibold w-56 flex-shrink-0">Location</div>
                                    <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                        <div class="flex flex-col flex-grow">
                                            <input type="text" class="" v-model.trim="employementLocation.val"
                                                placeholder="" @blur="clearValidity('employementLocation')" />
                                            <transition name="form-fade" mode="out-in">
                                                <p v-if="!employementLocation.isValid" class="h-4 text-xs text-red-600">
                                                    {{ employementLocation.msg }}
                                                </p>
                                            </transition>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-2/3 flex items-center mt-1 text-xs sm:text-sm lg:text-base">
                                    <div class="font-semibold w-56 flex-shrink-0">Position</div>
                                    <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                        <div class="flex flex-col flex-grow">
                                            <input type="text" class="" v-model.trim="employementPosition.val"
                                                placeholder="" @blur="clearValidity('employementPosition')" />
                                            <transition name="form-fade" mode="out-in">
                                                <p v-if="!employementPosition.isValid" class="h-4 text-xs text-red-600">
                                                    {{ employementPosition.msg }}
                                                </p>
                                            </transition>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-2/3 flex items-center mt-1 text-xs sm:text-sm lg:text-base">
                                    <div class="font-semibold w-56 flex-shrink-0">Salary Range</div>
                                    <div class="text-gray-600 flex items-center flex-grow"><span class="mr-4">:</span>
                                        <div class="flex flex-col flex-grow">
                                            <select class="ht-42" v-model.trim="salaryRange.val"
                                                @blur="clearValidity('salaryRange')">
                                                <option value="">Select Salary Range</option>
                                                <option value="Less than 9,000 AED">Less than 9,000 AED</option>
                                                <option value="10-30,000 AED">10-30,000 AED</option>
                                                <option value="31-60,000 AED">31-60,000 AED</option>
                                                <option value="61-90,000 AED">61-90,000 AED</option>
                                                <option value="More than 91,000 AED">More than 91,000 AED</option>
                                            </select>
                                            <transition name="form-fade" mode="out-in">
                                                <p v-if="!salaryRange.isValid" class="h-4 text-xs text-red-600">
                                                    {{ salaryRange.msg }}
                                                </p>
                                            </transition>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>
                </transition>
            </div>

            <div class="w-full flex justify-center mt-8">
                <div v-if="isLoading"
                    class="w-36 bg-gradient-to-r from-primary to-secondaryLight px-4 py-2 rounded-lg text-white flex items-center justify-center">
                    <base-spinner-with-text class-list="h-6 w-6 text-white" text="Updating..."
                        text-class-list="text-white"></base-spinner-with-text>
                </div>
                <button v-else type="submit"
                    class="w-36 bg-gradient-to-r from-primary to-secondaryLight px-4 py-2 rounded-lg text-white">Update</button>
            </div>

        </div>
    </form>
</template>

<script>
import gql from 'graphql-tag';
export default {
    name: "student-view",
    emits: ["update-student"],
    props: ["studentId"],
    data() {
        return {
            student: null,
            tabs: [
                { id: 'personal-information', name: 'Personal Information' },
                { id: 'academic-information', name: 'Academic Information' },
            ],
            activeTab: 'personal-information',
            indicatorOffset: 0,
            indicatorWidth: 181.359375,
            expireEid: {
                val: "",
                isValid: true,
                msg: "",
            },
            primaryPhone: {
                val: "",
                isValid: true,
                msg: "",
            },
            secondaryPhone: {
                val: "",
                isValid: true,
                msg: "",
            },
            secendoryEmail: {
                val: "",
                isValid: true,
                msg: "",
            },
            maritalStatus: {
                val: "",
                isValid: true,
                msg: "",
            },
            emirate: {
                val: "",
                isValid: true,
                msg: "",
            },
            city: {
                val: "",
                isValid: true,
                msg: "",
            },
            employed: {
                val: null,
                isValid: true,
                msg: "",
            },
            employer: {
                val: "",
                isValid: true,
                msg: "",
            },
            employementSector: {
                val: "",
                isValid: true,
                msg: "",
            },
            employementLocation: {
                val: "",
                isValid: true,
                msg: "",
            },
            employementPosition: {
                val: "",
                isValid: true,
                msg: "",
            },
            salaryRange: {
                val: "",
                isValid: true,
                msg: "",
            },
            collegeName: {
                val: "",
                isValid: true,
                msg: "",
            },
            collegeLocation: {
                val: "",
                isValid: true,
                msg: "",
            },
            collegeGraduationYear: {
                val: "",
                isValid: true,
                msg: "",
            },
            collegeYearOfstarting: {
                val: "",
                isValid: true,
                msg: "",
            },
            collegeAcademicMajors: {
                val: "",
                isValid: true,
                msg: "",
            },
            collegeGpa: {
                val: "",
                isValid: true,
                msg: "",
            },
            collegeSponsor: {
                val: null,
                isValid: true,
                msg: "",
            },
            schoolName: {
                val: "",
                isValid: true,
                msg: "",
            },
            schoolAverage: {
                val: "",
                isValid: true,
                msg: "",
            },
            schoolStream: {
                val: "",
                isValid: true,
                msg: "",
            },
            schoolGraduationYear: {
                val: "",
                isValid: true,
                msg: "",
            },
            schoolLocation: {
                val: "",
                isValid: true,
                msg: "",
            },
            formIsValid: true,
            isLoading: false,
            error: null,
        };
    },
    computed: {
        getProfilePicture() {
            return `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${this.studentId}/${this.student.entity}`;
        },
        getActiveTabStyle() {
            return {
                'width': `${this.indicatorWidth}px`,
                'transform': `translate3d(${this.indicatorOffset}px, 0px, 0px)`
            }
        },
        getOrgType() {
            if (this.student.entity == 'ATHS' || this.student.entity == 'STS') {
                return "School";
            } else {
                return "College";
            }
        },
        showHighSchoolDetailsView() {
            if (this.getOrgType == 'School') {
                return true;
            } else {
                return false;
            }
        },
        showHighSchoolDetailsEdit() {
            if (this.getOrgType == 'School') {
                return false;
            } else {
                return true;
            }
        },
        showUniversityDetailsView() {
            if (this.getOrgType == 'College') {
                return true;
            } else {
                return false;
            }
        },
        showUniversityDetailsEdit() {
            if (this.getOrgType == 'School') {
                if (this.student.student_status == 'AS') {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
    },
    watch: {
        activeTab() {
            const activeTabBtn = document.getElementById(`${this.activeTab}`);
            if (activeTabBtn) {
                this.indicatorOffset = activeTabBtn.offsetLeft;
                this.indicatorWidth = activeTabBtn.getBoundingClientRect().width;
            }
        },
        student() {
            this.primaryPhone.val = this.student.primary_phone ? this.student.primary_phone : '';
            this.secondaryPhone.val = this.student.secondary_phone ? this.student.secondary_phone : '';
            this.secendoryEmail.val = this.student.secondary_email ? this.student.secondary_email : '';
            this.maritalStatus.val = this.student.marital_status ? this.student.marital_status : '';
            this.expireEid.val = this.student.eid_expiry_date ? this.student.eid_expiry_date : '';
            this.emirate.val = this.student.emirate ? this.student.emirate : '';
            this.city.val = this.student.city ? this.student.city : '';
            this.employed.val = this.student.is_employed;
            // this.employer.val = this.student.employer ? this.student.employer : '';
            // this.employementSector.val = this.student.employement_sector ? this.student.employement_sector : '';
            // this.employementLocation.val = this.student.employement_location ? this.student.employement_location : '';
            // this.employementPosition.val = this.student.employement_position ? this.student.employement_position : '';
            // this.salaryRange.val = this.student.salary_range ? this.student.salary_range : '';
            this.collegeName.val = this.student.college_name ? this.student.college_name : '';
            this.collegeLocation.val = this.student.college_location ? this.student.college_location : '';
            this.collegeGraduationYear.val = this.student.college_graduation_year ? this.student.college_graduation_year : '';
            this.collegeYearOfstarting.val = this.student.college_year_of_starting ? this.student.college_year_of_starting : '';
            this.collegeAcademicMajors.val = this.student.college_academic_majors ? this.student.college_academic_majors : '';
            this.collegeGpa.val = this.student.college_gpa ? this.student.college_gpa : '';

            if (this.student.high_school_details) {
                this.schoolName.val = this.student.high_school_details.name;
                this.schoolAverage.val = this.student.high_school_details.average;
                this.schoolStream.val = this.student.high_school_details.stream;
                this.schoolGraduationYear.val = this.student.high_school_details.graduation_year;
                this.schoolLocation.val = this.student.high_school_details.location;
            }

            if (this.student.university_details) {
                this.collegeName.val = this.student.university_details.name;
                this.collegeLocation.val = this.student.university_details.location;
                this.collegeYearOfstarting.val = this.student.university_details.year_of_starting;
                this.collegeGraduationYear.val = this.student.university_details.graduation_year;
                this.collegeAcademicMajors.val = this.student.university_details.academic_majors;
                this.collegeGpa.val = this.student.university_details.gpa;
                this.collegeSponsor.val = this.student.university_details.sponsor;
            }

            if (this.student.employment_informations) {
                this.employer.val = this.student.employment_informations.employer;
                this.employementSector.val = this.student.employment_informations.sector;
                this.employementLocation.val = this.student.employment_informations.location;
                this.employementPosition.val = this.student.employment_informations.position;
                this.salaryRange.val = this.student.employment_informations.salary_range;
            }

            if (this.student.student_status == 'IG') {
                this.tabs.push({ id: 'employment-information', name: 'Employment Information' });
            }

        },
        'employed.val': function (newVal) {
            if (!newVal) {
                this.employer = {
                    val: "",
                    isValid: true,
                    msg: "",
                };
                this.employementSector = {
                    val: "",
                    isValid: true,
                    msg: "",
                };
                this.employementLocation = {
                    val: "",
                    isValid: true,
                    msg: "",
                };
                this.employementPosition = {
                    val: "",
                    isValid: true,
                    msg: "",
                };
                this.salaryRange = {
                    val: "",
                    isValid: true,
                    msg: "",
                };
            }
        },
    },
    mounted() {
        let $this = this;
        setTimeout(() => {
            const activeTabBtn = document.getElementById(`${$this.activeTab}`);
            if (activeTabBtn) {
                $this.indicatorOffset = activeTabBtn.offsetLeft;
                $this.indicatorWidth = activeTabBtn.getBoundingClientRect().width;
            }
        }, 1000);
    },
    apollo: {
        student() {
            return {
                query: gql`query GetStudentDetails($student_id: String!) {
                    student(student_id: $student_id) {
                        student_id
                        status
                        student_status
                        name_en
                        name_ar
                        entity
                        marital_status
                        campus
                        study_program
                        gpa
                        grad_year
                        grad_date
                        gender
                        birthdate
                        nationality
                        nationality_type
                        mother_natl_code
                        primary_phone
                        secondary_phone
                        eid
                        primary_email
                        secondary_email
                        notes
                        eid_expiry_date
                        emirate
                        city
                        location
                        is_employed
                        employer
                        employement_sector
                        employement_location
                        employement_position
                        salary_range
                        college_name
                        college_location
                        college_graduation_year
                        college_year_of_starting	
                        college_academic_majors
                        college_gpa
                        is_sponsor
                        high_school_details {
                            name
                            average
                            stream
                            graduation_year
                            location
                        }
                        university_details {
                            name
                            location
                            year_of_starting
                            graduation_year
                            academic_majors
                            gpa
                            sponsor
                        }
                        employment_informations {
                            employer
                            sector
                            location
                            position
                            salary_range
                        }
                    }
                }`,
                variables() {
                    return {
                        student_id: this.studentId,
                    }
                },
                fetchPolicy: 'cache-and-network'
            }
        },
    },
    methods: {
        formattedDate(date) {
            if (date) {
                const parsedDate = new Date(date);
                return parsedDate.toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                }).replace(/\//g, '-');
            } else {
                return "";
            }
        },
        selectTab(selectedTab) {
            this.activeTab = selectedTab;
        },
        getMaritalStatus(status) {
            if (status == 'S') {
                return "Single";
            } else if (status == 'M') {
                return "Married";
            } else if (status == 'W') {
                return "Widowed";
            } else if (status == 'D') {
                return "Divorced";
            } else if (status == 'U') {
                return "Unmarried";
            } else {
                return "";
            }
        },
        getStudentStatusclass(status) {
            switch (status) {
                case 'AS':
                    return 'text-green-600';
                case 'DA':
                    return 'text-red-500';
                case 'DB':
                    return 'text-red-600';
                case 'DF':
                    return 'text-blue-600';
                case 'DN':
                    return 'text-blue-400';
                case 'GR':
                    return 'text-yellow-400';
                case 'IG':
                    return 'text-yellow-600';
                case 'IS':
                    return 'text-yellow-500';
                case 'NS':
                    return 'text-red-400';
                case 'SA':
                    return 'text-red-700';
                case 'SB':
                    return 'text-red-400';
                case 'WD':
                    return 'text-red-400';
                case 'WS':
                    return 'text-red-400';
                default:
                    return '';
            }
        },
        replaceSemiColumn() {
            //.replace(/;/g, ', ')
        },
        allowNumbersOnly(event) {
            const charCode = event.which || event.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                event.preventDefault();
            }
        },
        clearValidity(input) {
            this[input].isValid = true;
            this[input].msg = "";
        },
        validateForm() {
            this.formIsValid = true;
            if (this.expireEid.val === "") {
                this.expireEid.isValid = false;
                this.expireEid.msg = "Expire EID must not be empty.";
                this.formIsValid = false;
            }
            // if (this.primaryPhone.val === "") {
            //     this.primaryPhone.isValid = false;
            //     this.primaryPhone.msg = "Primary Phone must not be empty.";
            //     this.formIsValid = false;
            // }
            if (this.secendoryEmail.val !== "") {
                const regexExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gi;
                if (!regexExp.test(this.secendoryEmail.val)) {
                    this.secendoryEmail.isValid = false;
                    this.secendoryEmail.msg = "The Personal email field must be a valid email address.";
                    this.formIsValid = false;
                }
            }
            // if (this.maritalStatus.val === "") {
            //     this.maritalStatus.isValid = false;
            //     this.maritalStatus.msg = "Marital Status must not be empty.";
            //     this.formIsValid = false;
            // }
            // if (this.employed.val === null) {
            //     this.employed.isValid = false;
            //     this.employed.msg = "Please select whether you are currently working or not.";
            //     this.formIsValid = false;
            // } else {
            if (this.employed.val) {
                if (this.employer.val === "") {
                    this.employer.isValid = false;
                    this.employer.msg = "Employer must not be empty.";
                    this.formIsValid = false;
                }
                if (this.employementSector.val === "") {
                    this.employementSector.isValid = false;
                    this.employementSector.msg = "Sector must not be empty.";
                    this.formIsValid = false;
                }
                if (this.employementLocation.val === "") {
                    this.employementLocation.isValid = false;
                    this.employementLocation.msg = "Location must not be empty.";
                    this.formIsValid = false;
                }
                if (this.employementPosition.val === "") {
                    this.employementPosition.isValid = false;
                    this.employementPosition.msg = "Position must not be empty.";
                    this.formIsValid = false;
                }
                if (this.salaryRange.val === "") {
                    this.salaryRange.isValid = false;
                    this.salaryRange.msg = "Salary Range must not be empty.";
                    this.formIsValid = false;
                }
            }
            // }

        },
        async submitForm() {
            this.validateForm();

            if (!this.formIsValid) {
                return;
            }

            const formData = {
                eid_expiry_date: this.expireEid.val,
                primary_phone: this.primaryPhone.val,
                secondary_phone: this.secondaryPhone.val,
                secondary_email: this.secendoryEmail.val,
                marital_status: this.maritalStatus.val,
                emirate: this.emirate.val,
                city: this.city.val,
                school_name: this.schoolName.val,
                school_average: this.schoolAverage.val,
                school_stream: this.schoolStream.val,
                school_graduation_year: this.schoolGraduationYear.val,
                school_location: this.schoolLocation.val,
                college_name: this.collegeName.val,
                college_location: this.collegeLocation.val,
                college_year_of_starting: this.collegeYearOfstarting.val,
                college_graduation_year: this.collegeGraduationYear.val,
                college_academic_majors: this.collegeAcademicMajors.val,
                college_gpa: this.collegeGpa.val,
                college_sponsor: this.collegeSponsor.val,
                is_employed: this.employed.val,
                emp_info_employer: this.employer.val,
                emp_info_sector: this.employementSector.val,
                emp_info_location: this.employementLocation.val,
                emp_info_position: this.employementPosition.val,
                emp_info_salary_range: this.salaryRange.val,
            };

            const UPDATE_STUDENT_MUTATION = gql`
                mutation updateStudent($student_id: String!, $input: UpdateStudentFormInput!) {
                    updateStudent(student_id: $student_id, input: $input) {
                        error
                        message
                    }
                }
            `;

            this.isLoading = true;

            try {

                await this.$apollo.mutate({
                    mutation: UPDATE_STUDENT_MUTATION,
                    variables: {
                        student_id: this.studentId,
                        input: formData
                    }
                }).then((data) => {
                    this.updateResponse = data;
                }).catch((error) => {
                    console.error(error)
                })

            } catch (error) {
                console.log(error);
                this.error = error.message || "Failed to authenticate, try later.";
            }

            if (this.error === null) {
                this.$emit('update-student');
            }

            this.isLoading = false;

        }
    },
}
</script>

<style lang="scss" scoped>
.bg-1 {
    background: linear-gradient(180deg, #fdd7ff 0%, white 100%);
}

.active-tab {
    box-shadow: rgb(221, 221, 221) 0px 1px 5px 1px;
    padding: 0px;
    transition: all 0.5s ease 0s;
    min-height: 40px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

input[type="text"],
input[type="email"],
input[type="number"],
input[type="password"],
input[type="date"],
select {
    @apply block w-full border rounded-lg py-2 px-2;
}

input[type="text"]:focus,
input[type="email"]:focus,
input[type="number"]:focus,
input[type="password"]:focus,
input[type="date"]:focus,
select:focus {
    outline: none;
    border-color: #bc1fa6;
    box-shadow: 0 0 0 2px #bc1fa680;
}

.form-fade-enter-active,
.form-fade-leave-active {
    transition: all 0.5s ease;
}

.form-fade-enter-from,
.form-fade-leave-to {
    opacity: 0;
    height: 0px;
}
</style>